<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.ab_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">                    
                    <el-form-item :label="aLang.ab_badge_holder">
                      <!-- <el-select
                        v-model="mData.tableRules.dataSearch.value.user_id"
                        :disabled="mData.viewMode == 'detail'"
                        clearable
                        filterable
                        placeholder="Nhập từ khóa để tìm kiếm"
                        no-data-text="Chưa có dữ liệu"
                        :filter-method="fn_findUser"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listFindUser"
                          :key="item.id"
                          :label="item.ho_ten.ho_ten"
                          :value="item.id"
                        ></el-option>
                      </el-select> -->
                        <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="ten_user"
                        :fetch-suggestions="querySearchNguoiDuocCap"
                        :placeholder="aLang.ab_enter_keywords_to_search"
                        :trigger-on-focus="true"
                        @select="handleSelectNguoiDuocCap"
                        @change="handleSelectNguoiDuocCap"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten.ho_ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item :label="aLang.ab_badge">
                      <!-- <el-input v-model="mData.tableRules.dataSearch.value.huy_hieu_id" clearable></el-input> -->
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.huy_hieu_id"
                        placeholder="Chọn huy hiệu"
                        :disabled="mData.viewMode == 'detail'"        
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listFindHuyHieu"
                          :key="item.id"
                          :label="item.ten.vi"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.ab_created_time">
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value.thoi_diem_tao"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>                   
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <!-- <el-button
                @click="fn_handle('create')"
                type="info"
                v-if="aRole('Officer')"
                plain
              >{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>

          <el-table-column
            prop="ten_nguoi_nhan"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.ab_badge_holder"
          ></el-table-column>
          <el-table-column
            prop="ten_huy_hieu"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.ab_badge"
            width="250"
          ></el-table-column>         
          <el-table-column
            prop="thoi_diem_tao"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.ab_badge_receipt"
            :formatter="fn_formatterDatetime"
            align="center"
            width="150"
          ></el-table-column>
          <!-- <el-table-column prop="ghi_chu" :sortable="mData.tableRules.allowSorting" label="Ghi chú"></el-table-column> -->
          <!-- <el-table-column
            prop="nguoi_cap_id"
            :sortable="mData.tableRules.allowSorting"
            label="Người cấp"
            width="200"
            align="center"
            
          ></el-table-column>-->
          <!-- <el-table-column
            prop="da_duyet"
            :sortable="mData.tableRules.allowSorting"
            label="Duyệt"
            width="80"
            align="center"
            
          >
            <template slot-scope="scope">             
              <el-checkbox
                v-model="scope.row.da_duyet"
                @change="fn_changeTrangThaiDuyet(scope.row.id, scope.row.da_duyet)"
                :disabled="!aRole('Officer')"
              ></el-checkbox>
            </template>
          </el-table-column>-->
          <el-table-column :label="aLang.c_action" align="center" width="120">
            <template slot-scope="scope">
              <!-- <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button> -->
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ThanhTichHuyHieuModel from "./ThanhTichHuyHieuModel";
import ThanhTichHuyHieuApi from "../../../moduleApi/ThanhTichHuyHieuApi";
import HuyHieuApi from "../../../moduleApi/HuyHieuApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";

export default {
  data() {
    return {
      ten_user:'',
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "ThanhTichHuyHieu", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(ThanhTichHuyHieuModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listHDV: [],
          listKDL:[],
          listDDAT: [],
          listHuyHieu: [],
          listFindHuyHieu: [],
          listFindUser:[],
        }
      }
    };
  },

  methods: {
    async querySearchNguoiDuocCap(queryString, cb) {
      queryString = queryString.trim();
      if (!queryString) {
        return;
      }

      let resHDV = await HuongDanVienApi.list({
        limit: 1000,
        filters: `ho_ten.ho_ten:regex_i:${queryString}`
      });
      if (resHDV.result && resHDV.result.length > 0) {
        this.mData.dataDefault.listFindUser = resHDV.result;
      } else {
        let resKhachDL = await KhachDuLichApi.list({
          limit: 1000,
          filters: `ho_ten.ho_ten:regex:${queryString}`
        });
        if (resKhachDL.result && resKhachDL.result.length > 0) {
          this.mData.dataDefault.listFindUser = resKhachDL.result;
        }
      }

      var results = queryString
        ? this.mData.dataDefault.listFindUser.filter(
            item =>
              item.ho_ten.ho_ten.toLowerCase().includes(queryString.toLowerCase())
          )
        : [];
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectNguoiDuocCap(item) {
      this.mData.tableRules.dataSearch.value.user_id = item.id;
      this.ten_user = item.ho_ten.ho_ten;
    },
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = await ThanhTichHuyHieuApi.list(dataFilter);

      let resData = MethodService.checkDifferentObject(
        MethodService.copyObject(ThanhTichHuyHieuModel.dataForm),
        res.result
      );
      let hdvIds = MethodService.findListItemDifferent(resData, "user_id");
      let hhIds = MethodService.findListItemDifferent(resData, "huy_hieu_id");

      let resHDVApi = await HuongDanVienApi.list({
        limit: hdvIds.length,
        filters: "id:in:" + hdvIds.join(",")
      });
      let resKDLApi = await KhachDuLichApi.list({
        limit: hdvIds.length,
        filters: "id:in:" + hdvIds.join(",")
      });
      let resDDATApi = await DiemDenAnToanApi.list({
        limit: hdvIds.length,
        filters: "id:in:" + hdvIds.join(",")
      });
      let resHHApi = await HuyHieuApi.list({
        limit: hhIds.length,
        filters: "id:in:" + hhIds.join(",")
      });

      this.mData.dataDefault.listHDV = resHDVApi.result;
      this.mData.dataDefault.listKDL = resKDLApi.result;
      this.mData.dataDefault.listDDATL = resDDATApi.result;
      this.mData.dataDefault.listHuyHieu = resHHApi.result;

      $.each(resData, (index, item) => {
        let huongDanVien = this.mData.dataDefault.listHDV.find(element => {
          return element.id == item.user_id;
        });
        if (huongDanVien) {
          item.ten_nguoi_nhan = huongDanVien.ho_ten.ho_ten;
        } else {
          let khachDuLich = this.mData.dataDefault.listKDL.find(element => {
            return element.id == item.user_id;
          });
          if (khachDuLich) {
            if(khachDuLich.ho_ten && khachDuLich.ho_ten.ho_ten && khachDuLich.ho_ten.ho_ten.trim() != ""){
              item.ten_nguoi_nhan = khachDuLich.ho_ten.ho_ten;
            }else{
              item.ten_nguoi_nhan = "Chưa có thông tin";
            }
            
          } else {
            let diemDenAnToan = this.mData.dataDefault.listDDAT.find(element => {
              return element.id == item.user_id;
            });
            if (diemDenAnToan) {
              item.ten_nguoi_nhan = diemDenAnToan.thong_tin_chung.ten;
            } else {
              item.ten_nguoi_nhan = "";
            }
          }          
        }

        let huyHieu = this.mData.dataDefault.listHuyHieu.find(element => {
          return element.id == item.huy_hieu_id;
        });
        if (huyHieu) {
          item.ten_huy_hieu = huyHieu.ten.vi;
        } else {
          item.ten_huy_hieu = "";
        }
      });

      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await ThanhTichHuyHieuApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await ThanhTichHuyHieuApi.disable(id, disable);
      this.fn_initTable();
    },

    async fn_changeTrangThaiDuyet(id, trangThai) {
      let data = {
        id: id,
        da_duyet: trangThai
      };
      if (trangThai) {
        await ThanhTichHuyHieuApi.updateChecked(data);
      } else {
        await ThanhTichHuyHieuApi.updateUnCheck(data);
      }
      this.fn_initTable();
    },

    async fn_findUser(query) {
      query = query.trim();
      if (!query) {
        return;
      }     

      let resHDV = await HuongDanVienApi.list({
        limit: 1000,
        filters: `ho_ten.ho_ten:regex_i:${query}`
      });
      if (resHDV.result && resHDV.result.length > 0) {
        this.mData.dataDefault.listFindUser = resHDV.result;
      } else {
        let resKhachDL = await KhachDuLichApi.list({
          limit: 1000,
          filters: `ho_ten.ho_ten:regex:${query}`
        });
        if (resKhachDL.result && resKhachDL.result.length > 0) {
          this.mData.dataDefault.listFindUser = resKhachDL.result;
        }
      }
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() {
      let resHHApi = await HuyHieuApi.list({
        limit: 1000,        
      });     
      this.mData.dataDefault.listFindHuyHieu = resHHApi.result;
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.mData.tableRules.dataSearch.value.user_id) {
        let resKhachDL = await KhachDuLichApi.findById(
          this.mData.tableRules.dataSearch.value.user_id
        );
        if (resKhachDL.result) {
          this.mData.dataDefault.listFindUser.push(resKhachDL.result);
        } else {
          let resHDV = await HuongDanVienApi.findById(
            this.mData.tableRules.dataSearch.value.user_id
          );
          if (resHDV.result) {
            this.mData.dataDefault.listFindUser.push(resHDV.result);
            this.ten_user=this.mData.dataDefault.listFindUser[0].ho_ten.ho_ten
          } else {
            let resDDAT = await DiemDenAnToanApi.findById(
              this.mData.tableRules.dataSearch.value.user_id
            );
            if (resDDAT.result) {
              this.mData.dataDefault.listFindUser.push(resDDAT.result);
              this.ten_user=this.mData.dataDefault.listFindUser[0].ho_ten.ho_ten
            } 
          }

        }
      }
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
<style lang="scss">
.el-select-dropdown__wrap {
    // max-width: 320px;
}
.el-autocomplete.inline-input{
  width: 100%;
}
</style>
